const isBackSpace = code => code === 8;

const isDelete = code => code === 46;

const isBackSpaceOrDelete = code => isBackSpace(code) || isDelete(code);

const isTab = code => code === 9;

const isEnter = code => code === 13;

const isEscape = code => code === 27;

const isArrowLeft = code => code === 37;

const isArrowRight = code => code === 39;

const isArrowTop = code => code === 38;

const isArrowBottom = code => code === 40;

const isArrow = code => isArrowLeft(code) || isArrowRight(code) || isArrowTop(code) || isArrowBottom(code);

const isChar = (code, character) => String.fromCharCode(code) === character;

module.exports = {
    isBackSpace,
    isDelete,
    isBackSpaceOrDelete,
    isTab,
    isEnter,
    isEscape,
    isArrowLeft,
    isArrowRight,
    isArrowTop,
    isArrowBottom,
    isArrow,
    isChar
};
